import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import logo from '../logo-cb-courtage.png';

const NAVY = '#1a2b4a';
const GOLD = '#c8a96e';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      const params = new URLSearchParams();
      params.append('username', email);
      params.append('password', password);
      const { data } = await axios.post('https://crm.cbcourtage.fr/api/login', params);
      if (data.role !== 'client') {
        setError('Accès réservé aux clients.');
        return;
      }
      localStorage.setItem('token', data.access_token);
      localStorage.setItem('client_user', JSON.stringify({ nom: data.nom, email, role: data.role }));
      navigate('/espace-client');
    } catch (err) {
      // Un seul message — « Email ou mot de passe incorrect » — couvrait autrefois
      // toutes les causes : serveur injoignable, compte bloqué après plusieurs
      // échecs, compte désactivé. Un client bloqué croyait s'être trompé de mot
      // de passe, réessayait, et prolongeait son blocage. Même défaut, même
      // remède que la page de connexion du CRM (corrigée le 06/08/2026).
      const statut = err.response?.status;
      const detail = err.response?.data?.detail;
      if (!err.response) {
        setError("Le service est momentanément injoignable. Réessayez dans quelques minutes.");
      } else if (statut === 429) {
        setError(typeof detail === 'string' ? detail
          : 'Trop de tentatives. Patientez quelques minutes avant de réessayer.');
      } else if (statut === 403) {
        setError("Votre accès est désactivé. Contactez CB Courtage.");
      } else if (statut === 401) {
        setError('Email ou mot de passe incorrect.');
      } else {
        setError(`Connexion impossible (erreur ${statut}). Contactez CB Courtage si cela persiste.`);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: `linear-gradient(135deg, ${NAVY} 0%, #243a5e 100%)`,
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      padding: '24px',
    }}>
      <div style={{
        background: '#fff', borderRadius: '20px',
        padding: '48px 40px', width: '100%', maxWidth: '400px',
        boxShadow: '0 20px 60px rgba(0,0,0,0.25)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: '36px' }}>
          <img src={logo} alt="CB Courtage" style={{ height: '52px', marginBottom: '20px' }} />
          <h1 style={{ fontSize: '20px', fontWeight: '700', color: NAVY, marginBottom: '6px' }}>Espace client</h1>
          <p style={{ color: '#94a3b8', fontSize: '14px' }}>Connectez-vous pour accéder à vos dossiers</p>
        </div>

        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>
              Email
            </label>
            <input
              type="email" required value={email} autoComplete="email"
              // Pas de majuscule automatique : un téléphone en mettait une en
              // tête d'adresse (le serveur tolère désormais la casse, mais
              // autant ne pas la provoquer).
              autoCapitalize="none" autoCorrect="off" spellCheck={false}
              onChange={e => setEmail(e.target.value)}
              placeholder="vous@exemple.fr"
              style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: '8px', fontSize: '15px', outline: 'none', transition: 'border-color 0.15s' }}
              onFocus={e => e.target.style.borderColor = GOLD}
              onBlur={e => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>
          <div>
            <label style={{ display: 'block', fontSize: '13px', fontWeight: '600', color: '#374151', marginBottom: '6px' }}>
              Mot de passe
            </label>
            <input
              type="password" required value={password} autoComplete="current-password"
              onChange={e => setPassword(e.target.value)}
              placeholder="••••••••"
              style={{ width: '100%', padding: '11px 14px', border: '1.5px solid #e2e8f0', borderRadius: '8px', fontSize: '15px', outline: 'none', transition: 'border-color 0.15s' }}
              onFocus={e => e.target.style.borderColor = GOLD}
              onBlur={e => e.target.style.borderColor = '#e2e8f0'}
            />
          </div>

          {error && (
            <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: '8px', padding: '10px 14px', color: '#dc2626', fontSize: '14px' }}>
              {error}
            </div>
          )}

          <button type="submit" disabled={loading} style={{
            background: NAVY, color: '#fff', border: 'none', borderRadius: '8px',
            padding: '13px', fontWeight: '700', fontSize: '15px', cursor: loading ? 'not-allowed' : 'pointer',
            opacity: loading ? 0.7 : 1, transition: 'background 0.15s, opacity 0.15s', marginTop: '4px',
          }}
            onMouseEnter={e => { if (!loading) e.target.style.background = '#243a5e'; }}
            onMouseLeave={e => e.target.style.background = NAVY}>
            {loading ? 'Connexion…' : 'Se connecter'}
          </button>
        </form>

        <div style={{ marginTop: '28px', textAlign: 'center' }}>
          <button onClick={() => navigate('/')} style={{ background: 'none', border: 'none', color: '#94a3b8', fontSize: '13px', cursor: 'pointer' }}>
            ← Retour au site
          </button>
        </div>
      </div>
    </div>
  );
}
